import { render, staticRenderFns } from "./seriesItem.vue?vue&type=template&id=1d53a090&"
import script from "./seriesItem.vue?vue&type=script&lang=js&"
export * from "./seriesItem.vue?vue&type=script&lang=js&"
import style0 from "./seriesItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports